import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://highervisionhawaii.com";
const DEFAULT_IMAGE = `${SITE_URL}/icon-512.png`;

/**
 * <Seo /> — per-page meta tags (title, description, OG, Twitter, canonical).
 *
 * Drop one at the top of any page component:
 *   <Seo title="Jobs" description="Browse Hawaii jobs and post your own." />
 *
 * Defaults flow through to the global tags in index.html when a prop is omitted.
 */
export default function Seo({ title, description, image, noindex = false }) {
  const { pathname } = useLocation();
  const canonical = `${SITE_URL}${pathname || "/"}`;
  const fullTitle = title ? `${title} · HigherVision` : "HigherVision · Hawaii's Social Network";
  const desc = description || "HigherVision is Hawaii's social network — find jobs, build teams, host events, promote your business, and grow your network across the Islands.";
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc}/>
      <link rel="canonical" href={canonical}/>
      <meta name="robots" content={noindex ? "noindex,follow" : "index,follow,max-image-preview:large"}/>
      <meta property="og:title" content={fullTitle}/>
      <meta property="og:description" content={desc}/>
      <meta property="og:url" content={canonical}/>
      <meta property="og:image" content={img}/>
      <meta name="twitter:title" content={fullTitle}/>
      <meta name="twitter:description" content={desc}/>
      <meta name="twitter:image" content={img}/>
    </Helmet>
  );
}
